import { IconButton, Text, Heading, HStack, VStack } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

import { ItemDetailsComponentProps } from '../../types';

export const PrivatePensionDetailsHeader: React.FC<ItemDetailsComponentProps> = ({
  onClose,
  offer,
}) => {
  return (
    <VStack space="stack.xxxs">
      <VStack>
        <HStack justifyContent="space-between">
          <Text color="neutral.dark">Detalhes da operação</Text>
          <IconButton
            testId={'icon-close'}
            icon="CloseModal"
            iconSize="xs"
            borderWidth={{ base: 0, lg: '1px' }}
            variant="rounded"
            backgroundColor="transparent"
            iconColor="brand.primary.principal"
            borderColor="brand.primary.principal"
            onPress={onClose}
            p={0}
          />
        </HStack>
        <Heading testId="direct-treasury-title" size="h4" fontSize="display">
          {offer.managerNameNormalized}
        </Heading>
      </VStack>
      <Box w="full" h="1px" bgColor="neutral.lightest" />
    </VStack>
  );
};
